import React from 'react';
import { Container, Bg, Handle, Input } from './ToggleSwitch.style';

interface ToggleSwitchProps {
  ariaLabel?: string;
  checked: boolean;
  disabled?: boolean;
  onValueChange: (value: boolean) => void;
  testID?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, disabled, ariaLabel, onValueChange, testID }) => {
  return (
    <Container
      onClick={() => {
        if (!disabled && onValueChange) onValueChange(!checked);
      }}
      aria-label={ariaLabel}
      aria-checked={checked}
      data-testid={testID}
    >
      <Bg checked={checked} disabled={disabled} />

      <Handle checked={checked} disabled={disabled} />

      <Input type="checkbox" role="switch" checked={checked} disabled={disabled} onChange={() => {}} />
    </Container>
  );
};

export default ToggleSwitch;
